import React, { Component } from 'react';
import {
  Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Divider,
  Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, FormHelperText
} from "@material-ui/core";
import OverLoader from "../../components/common/loader";
import { CreateProjectHours, UpdateProjectHours, UpdateProjectActivity, GetProjectActivities } from './TimeAction';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import moment from 'moment';
import isEmpty from "lodash.isempty";
import NumeralValue from './NumeralValue';

class ConsultantProjects extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isTimeRegistrationEditDialogOpen: false,
      hours: '',
      editdatum: '',
      editstunden: '',
      editkurzel: '',
      edittatigkeit: '',
      isTatigkeitEmpty: false,
      timeId: '',
      activityItem: '',
      error_validation: false
    }
    this.hoursUpdated = {};
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { project_time, error_validation } = this.props;
    if (prevProps.project_time !== project_time) {
      const updatedItem = project_time.projects.project_times[0]
      this.setState({
        timeId: updatedItem.id,
        editdatum: updatedItem.date,
        editstunden: updatedItem.hours,
        editkurzel: updatedItem.token,
        edittatigkeit: updatedItem.activity,
        project_id: updatedItem.project_id,
        user_id: updatedItem.user_id
      });
      if (project_time.projects.dailyproof === 1) {
        // this.setState({isTimeRegistrationEditDialogOpen: true})
        this.props.GetProjectActivities(updatedItem.project_id);
      }
    }
    if (error_validation) {
      if (prevProps.error_validation !== error_validation) {
        if (error_validation['project_times.hours']) {
          this.setState({ hour_error: error_validation['project_times.hours'][0], isTimeRegistrationHourErrorDialogOpen: true })
        } else if (error_validation['project_times.token']) {
          this.setState({ token_error: error_validation['project_times.token'][0], isTimeRegistrationEditDialogOpen: true })
        }
      }
    }
  }

  closeErrorTimeRegistrationDialog = () => {
    this.setState({ hour_error: '', isTimeRegistrationHourErrorDialogOpen: false })
  }

  launchEditTimeRegistrationDialog = (e, found) => {
    this.setState({
      timeId: found.id,
      editdatum: found.date,
      editstunden: found.hours,
      editkurzel: found.token,
      edittatigkeit: found.activity,
      project_id: found.project_id,
      user_id: found.user_id,
      // isTimeRegistrationEditDialogOpen: true,
      token_error: '',
    });
    this.props.GetProjectActivities(found.project_id);
  }

  updateTimeRegistrationFormAndCloseDialog = () => {
    if (this.state.edittatigkeit === "null" || this.state.edittatigkeit === null || this.state.edittatigkeit === "") {
      this.setState({ isTatigkeitEmpty: true })
    } else {
      const { month, year } = this.props;
      const { project_id, user_id, editkurzel, edittatigkeit, timeId } = this.state;
      this.props.UpdateProjectActivity(project_id, user_id, editkurzel, edittatigkeit, timeId, month, year);
      this.setState({ isTimeRegistrationEditDialogOpen: false, isTatigkeitEmpty: false });
    }
  }

  closeEditTimeRegistrationDialog = () => {
    this.setState({ isTimeRegistrationEditDialogOpen: false, isTatigkeitEmpty: false })
  }

  getActivityByKeyword = () => {
    const { activityItem } = this.state;
    this.setState({
      edittatigkeit: activityItem.activity,
      editkurzel: activityItem.token
    });
  }

  getWholeMonthDates = (year, month) => {
    const dates = [];
    const daysInMonth = new Date(year, month, 0).getDate();
    for (let i = 1; i <= daysInMonth; i++) {
      let parts = new Date(year + "-" + month + "-" + i);
      dates.push(parts);
    }
    return dates;
  }

  getWeeksForMonth = (year, month) => {
    let daysByWeek = [];
    let dates = this.getWholeMonthDates(year, month)
    dates.reduce((obj, dateString) => {
      let day = moment(dateString)
      const weekNumber = day.isoWeek();
      obj[weekNumber] = (obj[weekNumber] + 1) || 1;
      let weekFound = daysByWeek.find(w => w.weekNumber == weekNumber);
      if (!weekFound) {
        let totalDaysInWeek = obj[weekNumber];
        let dayInWeekObject = {weekNumber, totalDaysInWeek};
        daysByWeek.push(dayInWeekObject);
      } else {
        weekFound.totalDaysInWeek = obj[weekNumber];
      }
      return obj;
    }, {});
    return daysByWeek;
  }

  convertToDesiredDate(str) {
    let date = new Date(str),
      month = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), month, day].join("-");
  }

  getDaysNumber(year, month) {
    const dates = [];
    const daysInMonth = new Date(year, month, 0).getDate();
    for (let i = 1; i <= daysInMonth; i++) {
      let parts = new Date(year + "-" + month + "-" + i);
      dates.push(this.convertToDesiredDate(parts));
    }
    return dates;
  }

  createHours(hour, date, projectId, userId, cbFailure) {
    if (hour !== '') {
      const { CreateProjectHours, month, year } = this.props;
      CreateProjectHours(hour, date, projectId, userId, month, year, cbFailure);
    }
  }

  updateHours(timeId, hour, date, projectId, userId, recSet, cbFailure) {
    if (!this.hoursUpdated[timeId]) return;
    if (this.state.hours !== hour) {
      const { UpdateProjectHours, month, year } = this.props;
      UpdateProjectHours(timeId, hour, date, projectId, userId, month, year, cbFailure);
      this.setState({ hours: '' })
    } else if (this.state.hours === hour) {
      this.launchEditTimeRegistrationDialog(hour, recSet)
      this.setState({ hours: '' })
    }
  }

  getToleranceRegistering(month, year, days) {
    const startDate = moment([year, month - 1, 1]).format("YYYY-MM-DD");
    const daysInMonth = moment(startDate).daysInMonth();
    const endDate = moment(startDate).add(daysInMonth - 1, 'days').format("YYYY-MM-DD");
    return moment(endDate).add(days, 'days').format("YYYY-MM-DD");
  }

  getCurrentDate() {
    return moment().format("YYYY-MM-DD")
  }

  renderWeeks(weeksInMonth) {
    return <TableRow className={'time_reg_outer_rows'}>
      <TableCell colSpan={3}></TableCell>
      <TableCell></TableCell>
      <TableCell></TableCell>
      <TableCell></TableCell>
      {
        weeksInMonth.map((value, index) => (
          <TableCell align="center" key={`mi-${index}`} colSpan={value.totalDaysInWeek}>KW{value.weekNumber}</TableCell>
        ))
      }
    </TableRow>
  }

  renderDates(daysNumber) {
    return <TableRow className={'time_reg_outer_rows'}>
      <TableCell colSpan={3}></TableCell>
      <TableCell align="right"><span className={'marginRight5p'}>Tage</span></TableCell>
      <TableCell align="right"><span className={'marginRight5p'}>Tage</span></TableCell>
      <TableCell align="right"><span className={'marginRight5p'}>Std.</span></TableCell>
      {daysNumber.map((number, index) => {
        return <TableCell align="center" key={`mi-${index}`} className={this.daysBasedStyle(number)}>{number.split('-')[2]}</TableCell>
      })}
    </TableRow>
  }

  getPublicHolidays(public_holidays) {
    return public_holidays.map(item => item.date).filter((value, index, self) => self.indexOf(value) === index)
  }

  renderNames(daysNumber, publicHolidays) {
    return <TableRow className={'time_reg_outer_rows'}>
      <TableCell align="left"><span className={'marginLeft5p'}>Pr.Nr.</span></TableCell>
      <TableCell align="left"><span className={'marginLeft5p'}>Projekt</span></TableCell>
      <TableCell align="left"><span className={'marginLeft5p'}>Kunde</span></TableCell>
      <TableCell align="right"><span className={'marginRight5p'}>Verg</span></TableCell>
      <TableCell align="right"><span className={'marginRight5p'}>Ist</span></TableCell>
      <TableCell align="right"><span className={'marginRight5p'}>Ist</span></TableCell>
      {
        daysNumber.map((dateString, index) => {
          let currentDate = new Date(dateString);
          const dayName = currentDate.toLocaleDateString('de-DE', { weekday: 'short' })
          const weekend = currentDate.getDay() === 0 || currentDate.getDay() === 6;
          const pubHol = publicHolidays.includes(dateString);
          let className = weekend ? "weekends" : "allDays";
          if (pubHol) className = "publicHoliday";
          return <TableCell align="center" key={`mi-${index}`} style={{ width: '5px' }} className={`${className} ${this.daysBasedStyle(dateString)}  time_reg_outer_rows`}>{dayName}</TableCell>
        })
      }
    </TableRow>
  }

  renderBody(daysNumber, month, year) {
    return this.props.consultant_projects.projects.map((h, index) => (
      <TableRow key={`mi-${index}`} className={'time_reg_listing_body'}>
        <TableCell align="left"><span style={{ float: 'left' }}>{h.projectno}</span></TableCell>
        <TableCell align="left"><span className={'marginLeft5p'}>{h.projectname}</span></TableCell>
        <TableCell align="left"><span className={'marginLeft5p'}>{h.customer_name}</span></TableCell>
        <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(h.days_allocated)}</span></TableCell>
        <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(h.days_real)}</span></TableCell>
        <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(h.hours_real)}</span></TableCell>
        {this.renderMonthlyRecords(h, daysNumber, month, year)}
      </TableRow>
    ));
  }

  getTotalDayHoursAndPerWeekHours(daysNumber) {
    const totalDays = [];
    const totalWeekHours = [];
    const daysAllocated = [];
    const daysReal = [];
    const hoursReal = [];
    this.props.consultant_projects.projects.map((h) => {

      daysAllocated.push(parseFloat(h.days_allocated));
      daysReal.push(parseFloat(h.days_real));
      hoursReal.push(parseFloat(h.hours_real));

      daysNumber.map((currentDate) => {
        const found = h.project_times.find(item => currentDate === item.date)
        const emptyDate = found ? found.date : currentDate;
        const hours = found && found["hours"];
        const daysIndex = parseInt((currentDate.split('-')[2]));
        // Calculating Day Hour a Column Wise For All Projects
        if (!totalDays[daysIndex]) {
          totalDays[daysIndex] = [];
        }
        if (found && found['hours']) {
          totalDays[daysIndex].push({ Date: emptyDate, Hours: hours, ProjectId: h.id });
        } else {
          totalDays[daysIndex].push({ Date: emptyDate, Hours: 0, ProjectId: h.id });
        }

        // Calculating Week Hour A Same day
        if (!totalWeekHours[daysIndex]) {
          totalWeekHours[daysIndex] = [];
        }

        if (hours && !isNaN(hours)) {
          totalWeekHours[daysIndex].push({ Date: emptyDate, Hours: hours, ProjectId: h.id });
        } else {
          totalWeekHours[daysIndex].push({ Date: emptyDate, Hours: 0, ProjectId: h.id });
        }
      })

    });
    return { totalDays, totalWeekHours, daysAllocated, daysReal, hoursReal };
  }

  renderMonthlyRecords(h, daysNumber, month, year) {
    const toleranceRegistering = this.getToleranceRegistering(month, year, h.toleranceregistering);
    const DateToday = this.getCurrentDate();
    const access_rights = JSON.parse(localStorage.getItem('access_right'))

    return daysNumber.map((currentDate, currentDateIndex) => {
      const found = h.project_times.find(item => currentDate === item.date)
      const emptyDate = found ? found.date : currentDate;
      const hours = found && found["hours"];

      if ((Number(access_rights.time_reg_for_own) === 1 && Number(access_rights.time_reg_other_consultants_other) === 2 && this.props.other_access) ||
        (Number(access_rights.time_reg_for_own) === 2 && Number(access_rights.time_reg_other_consultants_other) === 1 && this.props.own_access) ||
        (Number(access_rights.time_reg_for_own) === 2 && Number(access_rights.time_reg_other_consultants_other) === 0) ||
        (Number(access_rights.time_reg_for_own) === 2 && Number(access_rights.time_reg_other_consultants_other) === 2) ||
        (Number(access_rights.time_reg_for_own) === 0 && Number(access_rights.time_reg_other_consultants_other) === 1 && this.props.own_access) ||
        (Number(access_rights.time_reg_for_own) === 0 && Number(access_rights.time_reg_other_consultants_other) === 2 && this.props.other_access)) {
        if (DateToday <= toleranceRegistering) {
          if (h.dailyproof === 1) {
            if (hours === undefined) {
              return <TableCell align="center" key={`mi-${currentDateIndex}-${emptyDate}`} className={this.daysBasedStyle(currentDate)}>
                <NumeralValue inputProps={{ maxLength: 5 }} required size="small" variant="outlined"
                  decimalSeparator="," decimalScale="1" fixedDecimalScale={true}
                  allowNegative={false}
                  value={this.state.isTimeRegistrationHourErrorDialogOpen && ''}
                  onBlur={(e, cbFailure) => this.createHours(e.target.value, emptyDate, h.id, h.user_id, cbFailure)}
                />
              </TableCell>
            } else {
              return <TableCell align="center" key={`mi-${currentDateIndex}-${emptyDate}-${found["id"]}`}
                onDoubleClick={(e) => this.launchEditTimeRegistrationDialog(e, found)} className={this.daysBasedStyle(currentDate)}>
                <NumeralValue inputProps={{ maxLength: 5 }} required size="small" variant="outlined"
                  value={Number(hours) === 0.0 ? '' : Number(hours)}
                  decimalSeparator="," decimalScale="1" fixedDecimalScale={true}
                  allowNegative={false}
                  onValueChange={(values) => {
                    this.hoursUpdated[found["id"]] = true;
                  }}
                  onFocus={(e) => {
                    this.hoursUpdated[found["id"]] = false;
                    this.setState({ hours: e.target.value })
                  }}
                  onBlur={(e, cbFailure) => {
                    this.updateHours(found["id"], e.target.value, emptyDate, h.id, h.user_id, found, cbFailure)
                  }}
                />
              </TableCell>
            }
          } else {
            if (hours === undefined) {
              return <TableCell align="center" key={`mi-${currentDateIndex}-${emptyDate}`} className={this.daysBasedStyle(currentDate)}>
                <NumeralValue inputProps={{ maxLength: 5 }} required size="small" variant="outlined"
                  decimalSeparator="," decimalScale="1" fixedDecimalScale={true}
                  allowNegative={false}
                  value={this.state.isTimeRegistrationHourErrorDialogOpen && ''}
                  onBlur={(e, cbFailure) => this.createHours(e.target.value, emptyDate, h.id, h.user_id, cbFailure)}
                />
              </TableCell>
            } else {
              return <TableCell align="center" key={`mi-${currentDateIndex}-${emptyDate}-${found["id"]}`} className={this.daysBasedStyle(currentDate)}>
                <NumeralValue inputProps={{ maxLength: 5 }} required size="small" variant="outlined"
                  value={Number(hours) === 0.0 ? '' : Number(hours)}
                  decimalSeparator="," decimalScale="1" fixedDecimalScale={true}
                  allowNegative={false}
                  onValueChange={(values) => {
                    this.hoursUpdated[found["id"]] = true;
                  }}
                  onFocus={(e) => {
                    this.hoursUpdated[found["id"]] = false;
                    this.setState({ hours: e.target.value })
                  }}
                  onBlur={(e, cbFailure) => {
                    this.updateHours(found["id"], e.target.value, emptyDate, h.id, h.user_id, found, cbFailure)
                  }}
                />
              </TableCell>
            }
          }
        } else {
          if (h.dailyproof === 1) {
            if (hours === undefined) {
              return <TableCell align="center" key={`mi-${currentDateIndex}`} className={this.daysBasedStyle(currentDate)}></TableCell>
            } else {
              return <TableCell align="center" key={`mi-${currentDateIndex}`} className={this.daysBasedStyle(currentDate)}>{hours.replace(/\./g, ',')}</TableCell>
            }
          } else {
            if (hours === undefined) {
              return <TableCell align="center" key={`mi-${currentDateIndex}`} className={this.daysBasedStyle(currentDate)}></TableCell>
            } else {
              return <TableCell align="center" key={`mi-${currentDateIndex}`} className={this.daysBasedStyle(currentDate)}>{hours === null ? '' : hours.replace(/\./g, ',')}</TableCell>
            }
          }
        }
      } else {
        if (h.dailyproof === 1) {
          if (hours === undefined) {
            return <TableCell align="center" key={`mi-${currentDateIndex}-${emptyDate}`} className={this.daysBasedStyle(currentDate)}></TableCell>
          } else {
            return <TableCell align="center" key={`mi-${currentDateIndex}-${emptyDate}-${found["id"]}`} className={this.daysBasedStyle(currentDate)}>
              <NumberFormat value={Number(hours)} size="small" variant="outlined"
                decimalSeparator="," decimalScale="1" fixedDecimalScale={true}
                allowNegative={false} disabled={true} />
            </TableCell>
          }
        } else {
          if (hours === undefined) {
            return <TableCell align="center" key={`mi-${currentDateIndex}-${emptyDate}`} className={this.daysBasedStyle(currentDate)}></TableCell>
          } else {
            return <TableCell align="center" key={`mi-${currentDateIndex}-${emptyDate}-${found["id"]}`} className={this.daysBasedStyle(currentDate)}>
              <NumberFormat value={Number(hours)} size="small" variant="outlined"
                decimalSeparator="," decimalScale="1" fixedDecimalScale={true}
                allowNegative={false} disabled={true} />
            </TableCell>
          }
        }
      }
    });
  }

  renderSummeFooter(daysNumber) {
    const { totalDays, daysAllocated, daysReal, hoursReal } = this.getTotalDayHoursAndPerWeekHours(daysNumber);

    if (totalDays.length > 0) {
      return <TableRow className={'time_reg_outer_rows'}>
        <TableCell colSpan={3} align="right">Summe</TableCell>
        <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(daysAllocated.reduce((a, b) => a + b, 0))}</span></TableCell>
        <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(daysReal.reduce((a, b) => a + b, 0))}</span></TableCell>
        <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(hoursReal.reduce((a, b) => a + b, 0))}</span></TableCell>
        {
          totalDays.map((currentDay, currentIndex) => {
            let currentDayTotal = (currentDay || [0]).reduce((currentTotal, currentDau) => (parseFloat(currentTotal) || 0) + parseFloat(currentDau.Hours), 0)
            return <TableCell align="right" key={`mi-${currentIndex}`} className={this.daysBasedStyle(currentDay[0].Date)}><span className={'marginRight5p'}>{this.getformattedhours(currentDayTotal)}</span></TableCell>
          })
        }
      </TableRow>
    } else {
      return <TableRow className={'time_reg_outer_rows'}>
        <TableCell colSpan={3} align="right">Summe</TableCell>
        <TableCell align="right"></TableCell>
        <TableCell align="right"></TableCell>
        <TableCell align="right"></TableCell>
        {
          daysNumber.map((currentDay, currentIndex) => {
            return <TableCell align="right" key={`mi-${currentIndex}`} className={this.daysBasedStyle(currentDay)}><span className={'marginRight5p'}>0,0</span></TableCell>
          })
        }
      </TableRow>
    }
  }

  renderSummeProFooter(daysNumber) {
    const { totalWeekHours } = this.getTotalDayHoursAndPerWeekHours(daysNumber);
    if (totalWeekHours.length > 0) {
      let perWeekTotal = 0;
      return <TableRow className={'time_reg_outer_rows'}>
        <TableCell colSpan={6} align="right">Summe pro Woche</TableCell>
        {
          totalWeekHours.map((sameDayHours, index) => {
            let hoursText = '';
            let currentDate = new Date(sameDayHours[0].Date);
            perWeekTotal += sameDayHours.reduce((sum, currentDay, index) => (parseFloat(sum) + parseFloat(currentDay.Hours)), 0);
            if (currentDate.getDay() === 0) // Reset Totals on Sundays
            {
              hoursText = perWeekTotal
              perWeekTotal = 0;
            }
            return <TableCell align="right" key={index} className={this.daysBasedStyle(sameDayHours[0].Date)}><span className={'marginRight5p'}>{this.getformattedhours(hoursText)}</span></TableCell> // Rest of days show empty text
          })
        }
      </TableRow>
    } else {
      return <TableRow className={'time_reg_outer_rows'}>
        <TableCell colSpan={6} align="right">Summe pro Woche</TableCell>
        {
          daysNumber.map((sameDayHours, index) => {
            return <TableCell align="right" key={index} className={this.daysBasedStyle(sameDayHours)}><span className={'marginRight5p'}>{new Date(sameDayHours).getDay() === 0 ? '0,0' : ''}</span></TableCell>
          })
        }
      </TableRow>
    }
  }

  daysBasedStyle = (date) => {
    let cssClass = '';
    let currentDate = new Date(date);
    if (currentDate.getDay() === 0) {
      cssClass = 'sundayStart'
    }
    else if (currentDate.getDay() === 1) {
      cssClass = 'mondayStart'
    }
    else if (currentDate.getDay() !== 0 && currentDate.getDay() !== 1) {
      cssClass = 'TimeRegCellRightBorder'
    }
    return cssClass;
  }

  getformattedhours(hours) {
    return <NumberFormat
      value={hours}
      displayType={'text'}
      decimalSeparator=','
      decimalScale={1}
      fixedDecimalScale={true}
      isNumericString={true}
    />
  }

  render() {

    const { consultant_projects, isloading, project_activities, public_holidays, month, year } = this.props;
    const access_rights = JSON.parse(localStorage.getItem('access_right'))

    const daysNumber = this.getDaysNumber(year, month)
    const weeksInMonth = this.getWeeksForMonth(year, month)
    const publicHolidays = this.getPublicHolidays(public_holidays)

    const {
      isTimeRegistrationEditDialogOpen,
      editdatum,
      editstunden,
      editkurzel,
      edittatigkeit,
      isTimeRegistrationHourErrorDialogOpen,
      hour_error,
      token_error,
      isTatigkeitEmpty,
    } = this.state;

    if (consultant_projects.length === 0) return null;

    return (
      <React.Fragment>
        {isloading && <OverLoader />}
        <Grid container item xs={3} spacing={1} style={Number(access_rights.time_reg_for_own) === 0 && (Number(access_rights.time_reg_other_consultants_other) === 1 || Number(access_rights.time_reg_other_consultants_other) === 2) && this.props.own_access ? { display: 'none' } : { marginBottom: '10px', zoom: '.9' }} className="TimeRegSearchResultsTableBorders monthTabel">
          <TableContainer component={Paper}>
            <Table size="small" aria-label="dense table">
              <TableHead className={'time_reg_outer_rows'}>
                <TableRow>
                  <TableCell>&nbsp;</TableCell>
                  <TableCell align="center"><span className={'marginRight5p'}>Tage</span></TableCell>
                  <TableCell align="center"><span className={'marginRight5p'}>Tage</span></TableCell>
                  <TableCell align="center"><span className={'marginRight5p'}>Std</span></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>&nbsp;</TableCell>
                  <TableCell align="center"><span className={'marginRight5p'}>Verg.</span></TableCell>
                  <TableCell align="center"><span className={'marginRight5p'}>Ist</span></TableCell>
                  <TableCell align="center"><span className={'marginRight5p'}>Ist</span></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow className={'time_reg_listing_body'}>
                  <TableCell component="th" scope="row" align={"right"}><span className={'marginRight5p'}>Summe extern</span></TableCell>
                  <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(consultant_projects.summary.tage_verg_extern)}</span></TableCell>
                  <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(parseFloat(consultant_projects.summary.tage_ist_extern).toFixed(1))}</span></TableCell>
                  <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(consultant_projects.summary.std_ist_extern)}</span></TableCell>
                </TableRow>
                <TableRow className={'time_reg_listing_body'}>
                  <TableCell component="th" scope="row" align={"right"}><span className={'marginRight5p'}>Summe intern</span></TableCell>
                  <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(consultant_projects.summary.tage_verg_intern)}</span></TableCell>
                  <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(parseFloat(consultant_projects.summary.tage_ist_intern).toFixed(1))}</span></TableCell>
                  <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(consultant_projects.summary.std_ist_intern)}</span></TableCell>
                </TableRow>
                <TableRow className={'time_reg_outer_rows'}>
                  <TableCell component="th" scope="row" align={"right"}><span className={'marginRight5p'}>Summe gesamt</span></TableCell>
                  <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(consultant_projects.summary.tage_verg_gesamt)}</span></TableCell>
                  <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(parseFloat(consultant_projects.summary.tage_ist_gesamt).toFixed(1))}</span></TableCell>
                  <TableCell align="right"><span className={'marginRight5p'}>{this.getformattedhours(consultant_projects.summary.std_ist_gesamt)}</span></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid container item xs={12} spacing={1} style={Number(access_rights.time_reg_for_own) === 0 && (Number(access_rights.time_reg_other_consultants_other) === 1 || Number(access_rights.time_reg_other_consultants_other) === 2) && this.props.own_access ? { display: 'none' } : { zoom: '.9' }} className="TimeRegSearchResultsTableBorders monthTabel">
          <TableContainer component={Paper}>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                {this.renderWeeks(weeksInMonth)}
                {this.renderDates(daysNumber)}
                {this.renderNames(daysNumber, publicHolidays)}
              </TableHead>
              <TableBody>
                {this.renderBody(daysNumber, month, year)}
                {this.renderSummeFooter(daysNumber)}
                {this.renderSummeProFooter(daysNumber)}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Dialog open={isTimeRegistrationEditDialogOpen} maxWidth="md">
          <DialogTitle id="form-dialog-title" className="text-center">Tätigkeit für erfasste
                        Stunden</DialogTitle>
          <Divider />
          <DialogContent className="p-60">
            <Grid container spacing={1} justify="center">
              <Grid item xs={3} style={{ paddingTop: '10px' }}>
                Datum
              </Grid>
              <Grid item xs={9}>
                <TextField required size="small" value={moment(editdatum).format("DD.MM.YYYY")}
                  disabled={true} variant="outlined" />
              </Grid>

              <Grid item xs={3} style={{ paddingTop: '10px' }}>
                Stunden
              </Grid>
              <Grid item xs={9}>
                <TextField disabled size="small" variant="outlined" value={editstunden === null ? "" : editstunden.replace(/\./g, ',')} />
              </Grid>

              <Grid item xs={3} style={{ paddingTop: '10px' }}>
                Kürzel
              </Grid>
              <Grid item xs={9}>
                <TextField required size="small" value={editkurzel === 'null' ? '' : editkurzel}
                  onChange={(e) => this.setState({ editkurzel: e.target.value })}
                  helperText={!isEmpty(token_error) ? token_error : ''}
                  error={!isEmpty(token_error) ? true : false}
                  disabled={true}
                  variant="outlined" />
              </Grid>

              <Grid item xs={3} style={{ paddingTop: '10px' }}>
                Tätigkeit
              </Grid>
              <Grid item xs={9}>
                <TextField fullWidth required multiline rows={8} rowsMax={Infinity} variant="outlined"
                  value={edittatigkeit === 'null' ? '' : edittatigkeit}
                  onChange={(e) => this.setState({ edittatigkeit: e.target.value })} />
                <FormHelperText error>{isTatigkeitEmpty && isTatigkeitEmpty ? 'Die Aktivität sollte nicht leer sein' : ''}</FormHelperText>
              </Grid>

              <Grid item xs={3} style={{ paddingTop: '10px' }}>
                Vordefinierte Tätigkeiten
              </Grid>
              <Grid item xs={9}>
                <Grid container>
                  <Grid item xs={10}>
                    <TextField
                      select
                      variant="outlined"
                      className="select-box"
                      size="small"
                      fullWidth
                      onChange={(e) => this.setState({ activityItem: e.target.value })}>
                      {project_activities && project_activities.map((item, index) => {
                        return <MenuItem value={item} key={index}>{item.keyword}</MenuItem>
                      })}
                    </TextField>
                  </Grid>
                  <Grid item xs={2}>
                    <Button variant="outlined" color="primary" className="btnleftmargin"
                      onClick={() => this.getActivityByKeyword()}>Verwenden</Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button variant="outlined" className="m-10"
              onClick={this.updateTimeRegistrationFormAndCloseDialog} color="primary">
              Speichern
                        </Button>
            <Button variant="outlined" className="m-10" onClick={this.closeEditTimeRegistrationDialog}
              color="secondary">
              Abbrechen
                        </Button>
          </DialogActions>
        </Dialog>

        {hour_error && <Dialog open={isTimeRegistrationHourErrorDialogOpen} maxWidth="sm">
          <DialogTitle id="form-dialog-title" className="text-center">Fehler</DialogTitle>
          <Divider />
          <DialogContent className="p-60">
            <Grid container spacing={1} justify="center">
              {hour_error}
            </Grid>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button variant="outlined" className="m-10" onClick={this.closeErrorTimeRegistrationDialog}
              color="secondary">
              OK
                        </Button>
          </DialogActions>
        </Dialog>}
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ timeRegistration }) => {
  return {
    isloading: timeRegistration.loading,
    error_validation: timeRegistration.error_message,
    project_time: timeRegistration.project_time,
    project_activities: timeRegistration.project_activities
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    CreateProjectHours: (hour, date, projectId, userId, month, year, cbFailure) => dispatch(CreateProjectHours(hour, date, projectId, userId, month, year, cbFailure)),
    UpdateProjectHours: (timeId, hour, date, projectId, userId, month, year, cbFailure) => dispatch(UpdateProjectHours(timeId, hour, date, projectId, userId, month, year, cbFailure)),
    UpdateProjectActivity: (projectId, userId, token, activity, timeId, month, year) => dispatch(UpdateProjectActivity(projectId, userId, token, activity, timeId, month, year)),
    GetProjectActivities: (projectId) => dispatch(GetProjectActivities(projectId)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsultantProjects);
